<script setup lang="ts">
defineProps<{ duration: number; dark?: boolean }>()

defineEmits(["click", "progress-finished"])
</script>

<template>
  <button
    type="button"
    class="relative ml-4 shrink-0 flex-col"
    @click="$emit('click')"
  >
    <ProgressRing
      class="absolute -top-[7px] right-[-7px] text-zinc-300"
      dark
      :radius="17"
      :duration
      :stroke="3"
      @progress-finished="$emit('progress-finished')"
    />
    <div
      class="inline-flex rounded-md focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
      :class="
        dark
          ? 'text-zinc-400 hover:text-zinc-300'
          : 'bg-white text-gray-400 hover:text-gray-500'
      "
    >
      <span class="sr-only">Close</span>
      <SvgoPikaClose class="size-5" aria-hidden="true" />
    </div>
  </button>
</template>
